// extracted by mini-css-extract-plugin
export var cardContainer = "_nr-0";
export var cardHeader = "_nr-2";
export var collapsedState = "_nr-3";
export var dragHandle = "_nr-5";
export var dragHandleIcon = "_nr-6";
export var dragging = "_nr-1";
export var titleArea = "_nr-4";